import React from 'react';

export interface ClientBrand {
  id: string;
  name: string;
  domain: string;
  category: string;
  shortDescription: string;
  url: string;
  logoType: 'fashion' | 'tech' | 'lighting' | 'security' | 'iot' | 'hardware';
  accentColor: string;
  logoUrl?: string;
  status?: 'active' | 'paused' | 'archived';
}

export const ALL_CLIENTS: ClientBrand[] = [
  {
    id: 'charles-tyrwhitt',
    name: 'Charles Tyrwhitt',
    domain: 'charlestyrwhitt.com',
    category: 'Luxury E-Commerce',
    shortDescription: 'Global British menswear & bespoke tailoring storefront',
    url: 'https://charlestyrwhitt.com',
    logoType: 'fashion',
    accentColor: '#0b1c30'
  },
  {
    id: 'charles-keith',
    name: 'Charles & Keith',
    domain: 'charleskeith.com/us',
    category: 'Fashion Retail',
    shortDescription: 'International fashion footwear, bags and accessories portal',
    url: 'https://charleskeith.com',
    logoType: 'fashion',
    accentColor: '#1a1a1a'
  },
  {
    id: 'brilliant-trade',
    name: 'Brilliant Trade',
    domain: 'brillianttrade.com.au',
    category: 'B2B Enterprise',
    shortDescription: 'Trade & wholesale electrical contractor ordering platform',
    url: 'https://brillianttrade.com.au',
    logoType: 'lighting',
    accentColor: '#0059bb'
  },
  {
    id: 'mayfield-lighting',
    name: 'Mayfield Lighting',
    domain: 'mayfieldlighting.com.au',
    category: 'Design Showcase',
    shortDescription: 'Bespoke custom lamp & luminaire design showcase',
    url: 'https://mayfieldlighting.com.au',
    logoType: 'lighting',
    accentColor: '#7c3aed'
  },
  {
    id: 'mercator',
    name: 'Mercator Australia',
    domain: 'mercator.com.au',
    category: 'Smart Living & Fans',
    shortDescription: 'Architectural lighting, ventilation and smart living solutions',
    url: 'https://mercator.com.au',
    logoType: 'lighting',
    accentColor: '#0284c7'
  },
  {
    id: 'verve-lighting',
    name: 'Verve Lighting',
    domain: 'vervelighting.com',
    category: 'Architectural Lighting',
    shortDescription: 'Commercial architectural luminaires & AI search optimization',
    url: 'https://vervelighting.com',
    logoType: 'lighting',
    accentColor: '#2563eb'
  },
  {
    id: 'brilliant-lighting',
    name: 'Brilliant Lighting',
    domain: 'brilliantlighting.com.au',
    category: 'Smart Home Electrical',
    shortDescription: 'Smart lighting, smart appliances and home electrical infrastructure',
    url: 'https://brilliantlighting.com.au',
    logoType: 'lighting',
    accentColor: '#ea580c'
  },
  {
    id: 'arlec',
    name: 'Arlec Australia',
    domain: 'arlec.com.au',
    category: 'Hardware & DIY',
    shortDescription: 'Trusted consumer electronic hardware and power management',
    url: 'https://arlec.com.au',
    logoType: 'hardware',
    accentColor: '#dc2626'
  },
  {
    id: 'grid-connect',
    name: 'Grid Connect',
    domain: 'grid-connect.com.au',
    category: 'IoT Ecosystem',
    shortDescription: 'Unified smart home automation IoT platform & mobile cloud sync',
    url: 'https://grid-connect.com.au',
    logoType: 'iot',
    accentColor: '#059669'
  },
  {
    id: 'davis-lighting',
    name: 'Davis Lighting',
    domain: 'davislighting.com.au',
    category: 'Industrial Lighting',
    shortDescription: 'High-output commercial, industrial and healthcare lighting systems',
    url: 'https://davislighting.com.au',
    logoType: 'lighting',
    accentColor: '#d97706'
  },
  {
    id: 'antsig',
    name: 'Antsig',
    domain: 'antsig.com',
    category: 'AV & Signal Tech',
    shortDescription: 'Audio-visual cabling, broadcast antenna & digital accessories',
    url: 'https://antsig.com',
    logoType: 'tech',
    accentColor: '#4f46e5'
  },
  {
    id: 'orion-security',
    name: 'Orion Security Systems',
    domain: 'orionsecuritysystems.com.au',
    category: 'Security Systems',
    shortDescription: 'Enterprise CCTV surveillance, smart locks and perimeter defense',
    url: 'https://orionsecuritysystems.com.au',
    logoType: 'security',
    accentColor: '#0f172a'
  }
];
